import { PageHeader } from '@fukuri-admins/ui/common';
import { CreateGroupForm } from '~/features/CreateGroupForm';
import styles from './index.module.scss';

export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[
          { label: '利用企業', href: '/clients' },
          { label: 'グループ', href: '/groups' },
          { label: '新規作成' },
        ]}
      />
      <div className={styles.content}>
        <span className={styles.content__title}>グループの新規作成</span>
        <CreateGroupForm />
      </div>
    </>
  );
};
